// ============================================
// モジュール読み込み
// ============================================
import { viewport } from './libs/switchViewport';
import { inViewAnm, lenisPageScroll, sideNav } from './libs/Scroll';
import { drawer, fixedHeader } from './libs/Header';
import { addAutoFunc, confirmForm } from './libs/Form';
// import { accordionFunc } from './libs/Accordion';
// import { createIndex } from './libs/CreateIndex';
// import { numKeyFunc } from './libs/Form';
import { articleTable, ScrollHintFunc } from './libs/ScrollHint';
// import { modal } from './libs/Modal';
// import { slider } from './libs/Slider';
import { tabFunc } from './libs/Tab';

// 実行
// ==========================
window.addEventListener('DOMContentLoaded', () => {
  viewport();
  fixedHeader();
  drawer();
  // megaMenu();
  // createIndex();
  addAutoFunc();
  lenisPageScroll();
  confirmForm();
  // accordionFunc();
  // numKeyFunc();
  articleTable();
  ScrollHintFunc();
  tabFunc();
  sideNav();
});

window.addEventListener('load', () => {
  document.body.classList.add('is-loaded');
  inViewAnm();
  // modal();
  // slider();
});
